"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentItem = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const ContentItem = ({ children, description, direction = "start", image, imageFocalPointX = "50%", imageFocalPointY = "50%", subhead, title }) => {
    const isStart = direction === "start";
    const contentMedia = (react_1.default.createElement(foundations_1.Box, { sx: {
            backgroundColor: "backgroundNeutral02",
            backgroundImage: image ? `url(${image})` : null,
            backgroundPosition: `${imageFocalPointX} ${imageFocalPointY}`,
            backgroundSize: "cover",
            borderStartStartRadius: isStart ? "medium" : "unset",
            borderEndStartRadius: isStart
                ? ["unset", "unset", "medium"]
                : ["medium", "medium", "unset"],
            borderStartEndRadius: isStart
                ? ["medium", "medium", "unset"]
                : ["unset", "unset", "medium"],
            borderEndEndRadius: isStart ? "unset" : "medium",
            overflow: "hidden",
            display: "flex",
            flex: 1,
            mb: isStart ? [0, 0, 1] : 1,
            marginInlineStart: isStart ? 1 : [1, 1, 0],
            marginInlineEnd: isStart ? [1, 1, 0] : 1,
            mt: isStart ? 1 : [0, 0, 1]
        } },
        react_1.default.createElement(foundations_1.Box, { sx: {
                // These numbers were taken by getting the aspect ratio
                // from the Figma designs
                // @ts-ignore
                pb: [`78%`, `60%`, `56%`],
                width: "100%"
            } })));
    const contentText = (react_1.default.createElement(foundations_1.Box, { sx: {
            display: "flex",
            flex: 1,
            flexDirection: "column",
            justifyContent: ["top", "top", "center"],
            px: [5, 10, 16],
            py: [10, 10, 24]
        } },
        title && (react_1.default.createElement(foundations_1.Text, { as: "h4", sx: {
                fontSize: [6, 7, 8],
                lineHeight: [6, 7, 8]
            } }, title)),
        subhead && (react_1.default.createElement(foundations_1.Subhead, { sx: {
                "-webkit-box-orient": "vertical",
                "-webkit-line-clamp": "2",
                color: "text02",
                display: "-webkit-box",
                mb: 0,
                mt: 1,
                overflow: "hidden",
                pb: description ? 3 : 0
            }, variant: "regular" }, subhead)),
        description && (react_1.default.createElement(foundations_1.Text, { as: "div", sx: {
                "-webkit-box-orient": "vertical",
                "-webkit-line-clamp": ["6", "4", "4"],
                color: "text02",
                display: "-webkit-box",
                mt: 1,
                overflow: "hidden"
            } }, description)),
        children));
    return (react_1.default.createElement(foundations_1.Box, { sx: {
            backgroundColor: "background01",
            borderRadius: "medium",
            boxShadow: "boxShadow01",
            display: "flex",
            flexWrap: "wrap",
            flex: 1
        } },
        react_1.default.createElement(foundations_1.Box, { sx: {
                display: "flex",
                flexDirection: "column",
                width: ["100%", null, "50%"]
            } }, isStart ? contentMedia : contentText),
        react_1.default.createElement(foundations_1.Box, { sx: {
                display: "flex",
                flexDirection: "column",
                width: ["100%", null, "50%"]
            } }, isStart ? contentText : contentMedia)));
};
exports.ContentItem = ContentItem;
//# sourceMappingURL=ContentItem.js.map